import { forwardRef, useEffect, useState } from 'react';
import {
  NumberFormatBase,
  NumberFormatValues,
  NumericFormatProps,
  SourceInfo,
} from 'react-number-format';

const MicroInputBase = forwardRef((props: NumericFormatProps, ref) => {
  const { onValueChange, value: propsValue, ...otherProps } = props;
  const [value, setValue] = useState(propsValue);
  const format = (value: string) => {
    const { maximumFractionDigits, minimumFractionDigits } = Intl.NumberFormat(
      'pt-BR',
      {
        style: 'currency',
        currency: 'BRL',
      }
    ).resolvedOptions();

    const numericValue = Number(value);

    const number =
      numericValue < Number.MAX_SAFE_INTEGER
        ? numericValue / 100
        : Number(value.slice(0, -1)) / 100;

    return number.toLocaleString('pt-BR', {
      maximumFractionDigits,
      minimumFractionDigits,
    });
  };

  const jumpCursorToEnd = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.selectionStart = e.target.value.length;
  };

  const handleChange = (values: NumberFormatValues, sourceInfo: SourceInfo) => {
    setValue(values.floatValue);
    onValueChange && onValueChange(values, sourceInfo);
  };

  useEffect(() => {
    if (value !== propsValue) setValue(propsValue);
  }, [propsValue, value]);

  return (
    <NumberFormatBase
      {...otherProps}
      value={value}
      format={format}
      onFocus={jumpCursorToEnd}
      onValueChange={handleChange}
      getInputRef={ref}
      valueIsNumericString
    />
  );
});

MicroInputBase.displayName = 'MicroInputBase';
export default MicroInputBase;
